import styled from 'styled-components';

import media from '../../styles/media.style';
import { PAGE_WIDTH } from '../../styles/variables.style';

export const Wrapper = styled.div`
  margin: auto;
  max-width: 100%;
  padding: 15px 15px 55px;
  width: ${PAGE_WIDTH}px;

  ${media.tabletP`
    padding: 75px;
  `};

  ${media.desktop`
    padding: 75px 190px 150px;
  `};
`;

export const PageTitle = styled.div`
  font-family: FuturaStd;
  font-size: 28px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.3px;
  text-transform: uppercase;
`;

export const Section = styled.div`
  margin-top: 45px;

  ${media.desktop`
    display:flex;
    margin-top: 100px;
  `};
`;

export const SectionTitle = styled.div`
  padding-right: 20px;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  text-transform: uppercase;

  ${media.desktop`
    width: calc(100% / 3);
  `};
`;

export const SectionItems = styled.div`
  margin-top: 25px;

  ${media.tabletL`
    column-count: 2;
  `};

  ${media.desktop`
    margin-top: 0;
    width: calc(100% * 2 / 3);
  `};
`;

export const SectionItem = styled.div`
  display: inline-block;
  margin-bottom: 40px;
  padding-right: 20px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemTitle = styled.div``;

export const Subitems = styled.div``;

export const Subitem = styled.div`
  font-family: FuturaStd;
  font-size: 16px;
  line-height: 1;
  letter-spacing: 0.4px;
  margin-top: 15px;
  color: #808080;

  &:hover {
    text-decoration: underline;
  }
`;

export const Subcategories = styled.div``;

export const Subcategory = styled.div`
  margin-top: 25px;

  &:hover {
    text-decoration: underline;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Sitemap/Sitemap.style.js